import { render, staticRenderFns } from "./affix.vue?vue&type=template&id=30ec6e46&scoped=true&"
import script from "./affix.vue?vue&type=script&lang=js&"
export * from "./affix.vue?vue&type=script&lang=js&"
import style0 from "./affix.vue?vue&type=style&index=0&id=30ec6e46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ec6e46",
  null
  
)

export default component.exports